import { queryOptions, useQuery, useQueryClient } from '@tanstack/react-query';
import { api, unwrap } from '@/lib/api';
import { getImpersonation } from '@/lib/impersonation';
import { reconcileTenantId } from '@/lib/membership';
import { useSession } from '@/stores/session';

export const meQueryKey = ['me'] as const;

export const meQueryOptions = queryOptions({
  queryKey: meQueryKey,
  queryFn: async () => {
    const me = await unwrap(api.GET('/v1/me'));
    // Every sign-in, sign-up and reload loads /me first: drop a stale shop id left by a previous account here.
    if (!getImpersonation()) {
      const session = useSession.getState();
      session.setTenant(reconcileTenantId(me.memberships, session.tenantId));
    }
    return me;
  },
  staleTime: 60_000,
});

/** Signed-in user + all memberships. Not tenant-scoped: use `useMembership()` / `useTenant()` inside `_app`. */
export function useMe() {
  return useQuery(meQueryOptions);
}

/** Re-fetch /v1/me (terminology, uiMode, branches and permissions live there). Call after changing them. */
export function useRefreshMe() {
  const qc = useQueryClient();
  return () => qc.invalidateQueries({ queryKey: meQueryKey });
}
